import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { PageMetaManager } from './components/PageMetaManager';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesOverviewPage } from './pages/ServicesOverviewPage';
import { ICAMPage } from './pages/ICAMPage';
import { ICAMCapabilitiesPage } from './pages/ICAMCapabilitiesPage';
import { ICAMResourcesPage } from './pages/ICAMResourcesPage';
import { ProgramManagementPage } from './pages/ProgramManagementPage';
import { PMAgilePage } from './pages/PMAgilePage';
import { PMPMOPage } from './pages/PMPMOPage';
import { AboutPage } from './pages/AboutPage';
import { LeadershipPage } from './pages/LeadershipPage';
import { CareersPage } from './pages/CareersPage';
import { PartnersPage } from './pages/PartnersPage';
import { CertificationsPage } from './pages/CertificationsPage';
import { ContractVehiclesPage } from './pages/ContractVehiclesPage';
import { NasaSewpPage } from './pages/NasaSewpPage';
import { CommunityPage } from './pages/CommunityPage';
import { ContactPage } from './pages/ContactPage';
// Existing ServiceNow Pages
import { ServiceNowHomePage } from './pages/ServiceNowHomePage';
import { ServicesPage as ServiceNowServicesPage } from './pages/ServicesPage';
import { SecureOnPremisePage } from './pages/SecureOnPremisePage';
import { ThoughtLeadershipPage } from './pages/ThoughtLeadershipPage';
import { CalculatorPage } from './pages/CalculatorPage';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { AIServicesPage } from './pages/AIServicesPage';
import { ArticlePage } from './pages/ArticlePage';
import { CrossInstanceSyncChecklistPage } from './pages/CrossInstanceSyncChecklistPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppLayout() {
  return <div className="min-h-screen flex flex-col font-body" data-id="element-0" data-mp="34x1hg4gh72u">
      <Navigation data-id="element-1" data-mp="3udavo55x0h34" />
      <main className="flex-1" data-id="element-2" data-mp="3ubrgkhvzwc2x">
        <Routes data-id="element-3" data-mp="3ucje3y95kjvu">
          <Route path="/" element={<HomePage data-id="element-5" data-mp="d57g95652mk4" />} data-id="element-4" data-mp="3uf5gljh6s977" />

          {/* Services Routes */}
          <Route path="/services" element={<ServicesOverviewPage data-id="element-7" data-mp="85uktw17c75x" />} data-id="element-6" data-mp="d2l8p5j9071w" />
          <Route path="/services/ai" element={<AIServicesPage data-id="element-9" data-mp="83qgjcze5654" />} data-id="element-8" data-mp="86w4uq0743zs" />

          {/* Identity & Access Management Sub-site */}
          <Route path="/services/identity-access-management" element={<ICAMPage data-id="element-11" data-mp="3bncpxvplb02n" />} data-id="element-10" data-mp="3gja5w0wxy4ew" />
          <Route path="/services/identity-access-management/capabilities" element={<ICAMCapabilitiesPage data-id="element-13" data-mp="3qc96yi9mjnfe" />} data-id="element-12" data-mp="3bnurn7v0u6hy" />
          <Route path="/services/identity-access-management/resources" element={<ICAMResourcesPage data-id="element-15" data-mp="3ljphoo1kr3ur" />} data-id="element-14" data-mp="3qdaj6q2dmfyp" />

          {/* Program & Project Management Sub-site */}
          <Route path="/services/program-and-project-management" element={<ProgramManagementPage data-id="element-17" data-mp="2svtnbpzh9o15" />} data-id="element-16" data-mp="2xtv6eawwlncm" />
          <Route path="/services/program-and-project-management/agile" element={<PMAgilePage data-id="element-19" data-mp="18e19djimhmji" />} data-id="element-18" data-mp="2sur0pu96u7r1" />
          <Route path="/services/program-and-project-management/pmo" element={<PMPMOPage data-id="element-21" data-mp="1d47xzjd4x71r" />} data-id="element-20" data-mp="18cq57il9mcrv" />

          {/* ServiceNow Sub-site Routes */}
          <Route path="/services/servicenow" element={<ServiceNowHomePage data-id="element-23" data-mp="ygd2xwbnmqli" />} data-id="element-22" data-mp="1d6kk88pxe3km" />
          <Route path="/services/servicenow/services" element={<ServiceNowServicesPage data-id="element-25" data-mp="13e54li23pr2w" />} data-id="element-24" data-mp="yheqv1drr7kn" />
          <Route path="/services/servicenow/secure-on-premise" element={<SecureOnPremisePage data-id="element-27" data-mp="1r3r64c5y4ie2" />} data-id="element-26" data-mp="13f7txljrzlgp" />
          <Route path="/services/servicenow/thought-leadership" element={<ThoughtLeadershipPage data-id="element-29" data-mp="1w3vl1xr7h526" />} data-id="element-28" data-mp="1r4se27ro0ork" />
          <Route path="/services/servicenow/thought-leadership/:slug" element={<ArticlePage data-id="element-31" data-mp="1i4cdp767xxqx" />} data-id="element-30" data-mp="1w2tzv0gh726q" />
          <Route path="/services/servicenow/calculator" element={<CalculatorPage data-id="element-33" data-mp="1m4mvdh3diclm" />} data-id="element-32" data-mp="1i318r411ejy8" />
          <Route path="/services/servicenow/case-studies" element={<CaseStudiesPage data-id="element-35" data-mp="6onqqfsysyq4" />} data-id="element-34" data-mp="1m3uxfzmb02s6" />

          {/* Resources */}
          <Route path="/resources/cross-instance-sync-checklist" element={<CrossInstanceSyncChecklistPage data-id="element-37" data-mp="aq98ofkcw376" />} data-id="element-36" data-mp="6n4bmsj1otpx" />

          {/* About Us Routes */}
          <Route path="/about-us" element={<AboutPage data-id="element-39" data-mp="qxxbx986om0r" />} data-id="element-38" data-mp="qxnmbmr1wgvl" />
          <Route path="/about-us/our-team" element={<LeadershipPage data-id="element-41" data-mp="m5x5cxxlyuv7" />} data-id="element-40" data-mp="qz8fb7xpvrrc" />
          <Route path="/about-us/partners" element={<PartnersPage data-id="element-43" data-mp="h7c54yicwb6r" />} data-id="element-42" data-mp="m5ni3i3y71t7" />
          <Route path="/about-us/certifications" element={<CertificationsPage data-id="element-45" data-mp="h7m070i9d8jb" />} data-id="element-44" data-mp="h6kl8ky4g1wb" />
          <Route path="/about-us/community" element={<CommunityPage data-id="element-47" data-mp="c9kh4fku197u" />} data-id="element-46" data-mp="c8j3c3cfm8mf" />
          <Route path="/about-us/contract-vehicles" element={<ContractVehiclesPage data-id="element-49" data-mp="19uyj90p7my7v" />} data-id="element-48" data-mp="c6eo4p931n6u" />
          <Route path="/about-us/contract-vehicles/nasa-sewp-vi" element={<NasaSewpPage data-id="element-51" data-mp="14xyfiwfu27jx" />} data-id="element-50" data-mp="19tx7sv4a89pm" />

          {/* Other Routes */}
          <Route path="/careers" element={<CareersPage data-id="element-53" data-mp="zwsjaomys25n" />} data-id="element-52" data-mp="zxty9473p8sn" />
          <Route path="/contact-us" element={<ContactPage data-id="element-55" data-mp="vw8lrjyhawiz" />} data-id="element-54" data-mp="zw0mjahmryds" />
        </Routes>
      </main>
      <Footer data-id="element-56" data-mp="vvp3g24x264f" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-57" data-mp="3kokk9alp8wxs">
      <ScrollToTop data-id="element-58" data-mp="3kp42ksf9hncc" />
      <PageMetaManager data-id="element-59" data-mp="3kpm70cc2v7vc" />
      <AppLayout data-id="element-60" data-mp="3klq0llaifg5f" />
    </BrowserRouter>;
}